import React from 'react';
import FindCustomerSnippet from '../FindCustomer/FindCustomerSnippet';

export default function FindCustomerWrapper({ customer, setCustomer, onTabChange }) {
    const handleCustomerSelected = (selectedCustomer) => {
        // Update parent state when customer is selected
        if (selectedCustomer) {
            setCustomer(selectedCustomer);
            // Switch to Apply Coupon tab (index 3) after customer is set
            if (onTabChange) {
                onTabChange(null, 3);
            }
        }
    };

    const handleFindCustomerOption = (option, selectedCustomerUID, selectedCustomer) => {
        // Handle FindCustomerOptions in QuickLink context
        // Switch to appropriate tab based on option
        switch (option) {
            case 'QuickSignup':
            case 'NewCustomer':
                // Switch to Quick Signup tab (index 1)
                if (onTabChange) {
                    onTabChange(null, 1);
                }
                break;
            case 'QuickEdit':
                // Set the selected customer and switch to Quick Edit tab (index 2)
                if (selectedCustomer && setCustomer) {
                    setCustomer(selectedCustomer);
                }
                if (onTabChange) {
                    onTabChange(null, 2);
                }
                break;
            case 'ViewCustomer':
                // Switch to Quick Edit tab (index 2) if customer is selected
                if (selectedCustomerUID && onTabChange) {
                    onTabChange(null, 2);
                }
                break;
            default:
                console.log('Unknown option:', option);
        }
    };

    return (
        <FindCustomerSnippet
            hideHeader={true}
            onCustomerSelected={handleCustomerSelected}
            onFindCustomerOption={handleFindCustomerOption}
        />
    );
}

